import React from 'react';
import { flattenToAppURL } from '@plone/volto/helpers';
import './TeamView.css';

const TeamView = (props) => {
  const { content } = props;

  return (
    <div className="team-view">
      {/* <h1 className="page-title">{content.title}</h1> */}
      <div className="team-member">
        {content.team_member_image && (
          <img
            src={flattenToAppURL(
              content.team_member_image.scales.great.download,
            )}
            alt={content.title}
            className="team-member-image"
          />
        )}
        <h2 className="team-member-name">{content.team_member_name}</h2>
        <p className="team-member-occupation">{content.occupation}</p>
        {content.social_media_icon && (
          <img
            src={flattenToAppURL(
              content.social_media_icon.scales.great.download,
            )}
            alt="Social Media"
            className="social-media-icon"
          />
        )}
      </div>
    </div>
  );
};

export default TeamView;
